<template>
  <VDialogV3
    title="Отправить уведомление о приёмке"
    position="right"
    width="600px"
    :entity="receipt"
    :submit-disabled="submitDisabledReason"
    @submit="send"
  >
    <section>
      <VFormItem>
        <VSelectV2
          class="search-select"
          :model-value="null"
          :data="personsSource"
          placeholder="Введите ФИО сотрудника"
          @input="addReceiver"
        />
      </VFormItem>
    </section>

    <section class="grid-block">
      <header>Получатели</header>

      <div class="content">
        <VDataGridV2
          :data="receivers"
          class="fill"
          sticky
        >
          <VDataGridColumnV2
            id="empty"
            width="10px"
          />

          <VDataGridColumnV2
            id="name"
            label="ФИО"
            width="200px"
            content-class="ellipsis"
          >
            <template #default="{ row }">
              <div class="ellipsis" :title="row.name">
                {{ row.name }}
              </div>
            </template>
          </VDataGridColumnV2>

          <VDataGridColumnV2
            id="email"
            label="Email"
            width="250px"
            content-class="ellipsis"
          >
            <template #default="{ row }">
              <div class="nowrap ellipsis" :title="row.email">
                {{ row.email }}
              </div>
            </template>
          </VDataGridColumnV2>

          <VDataGridColumnV2
            id="actions"
            width="52px"
          >
            <template #default="{ row }">
              <VButton
                material="delete"
                @click="removeReceiver(row)"
              />
            </template>
          </VDataGridColumnV2>

          <template #empty>
            Нет получателей
          </template>
        </VDataGridV2>
      </div>
    </section>
  </VDialogV3>
</template>

<script lang="ts">

import Core            from '@/core/Core';
import PersonsService  from '@/domains/Persons/PersonsService';
import ReceiptsService from '@/domains/Receipts/ReceiptsService';

import type Person  from '@/domains/Persons/Person';
import type Receipt from '@/domains/Receipts/Receipt';

export default defineComponent({
  name: 'ReceiptNotificationDialog',

  props: {
    /** Приёмка, по которой отправляем уведомление. Бэку уходит только её id. */
    receipt: {
      type:     Object as PropType<Receipt>,
      required: true,
    },
  },

  emits: ['close'],

  data() {
    return {
      /** Источник опций селектора: поиск по персонам при вводе. */
      personsSource: Core.loader.select(({ pattern }) => PersonsService.searchPersons(pattern)),
      receivers:     [] as Person[],
    };
  },

  computed: {
    submitDisabledReason(): string | null {
      if (this.receivers.length === 0) {
        return 'Добавьте хотя бы одного получателя';
      }
      else {
        return null;
      }
    },
  },

  methods: {
    /**
     * Выбор в селекторе сразу кладёт персону в таблицу.
     * Значение селектора намеренно не хранится (:model-value="null") — он
     * работает как поиск, а не как поле с выбранным значением: после выбора
     * VSelectV2 сам гасит фокус и очищает введённый текст.
     */
    addReceiver(person: Person | null): void {
      if (person === null) {
        // очистка селектора — добавлять нечего
      }
      else {
        const isDuplicate = this.receivers.some(receiver => receiver.id === person.id);

        if (isDuplicate) {
          // уже в таблице
        }
        else {
          this.receivers.push(person);
        }
      }
    },

    removeReceiver(receiver: Person): void {
      this.receivers = this.receivers.filter(item => item.id !== receiver.id);
    },

    async send(): Promise<void> {
      const isSent = await ReceiptsService.sendNotification(this.receipt, this.receivers);

      if (isSent) {
        this.$core.dialogs.ReceiptNotificationDialog.hide();
      }
    },
  },
});
</script>
